import type { TrackMetricBodyTags } from './trackMetricBodyTags';

export type TrackMetricBody = {
  name: string;
  tags?: TrackMetricBodyTags;
  type: string;
  value: number;
};
